import React, { useEffect, useState } from "react";
import AppShell from "@/components/layout/AppShell";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import api from "@/lib/api";
import { toast } from "sonner";
import { Check, X, Trash2 } from "lucide-react";

export default function AdminGallery() {
  const [tab, setTab] = useState("pending");
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get("/gallery", { params: { status: tab } }); setItems(data || []); };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [tab]);

  const approve = async (id) => { await api.post(`/gallery/${id}/approve`); toast.success("Approved"); load(); };
  const reject = async (id) => { await api.post(`/gallery/${id}/reject`); toast.success("Rejected"); load(); };
  const remove = async (id) => { if (!window.confirm("Delete photo?")) return; await api.delete(`/gallery/${id}`); toast.success("Deleted"); load(); };

  return (
    <AppShell variant="admin" title="Gallery moderation">
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="pending" data-testid="gal-tab-pending">Pending</TabsTrigger>
          <TabsTrigger value="approved" data-testid="gal-tab-approved">Approved</TabsTrigger>
          <TabsTrigger value="rejected" data-testid="gal-tab-rejected">Rejected</TabsTrigger>
        </TabsList>
      </Tabs>
      {items.length === 0 ? <Card className="mt-4 p-10 text-center text-muted-foreground border-dashed">No items.</Card> :
        <div className="mt-4 grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {items.map((g) => (
            <Card key={g.id} className="overflow-hidden">
              <div className="aspect-square bg-[hsl(var(--secondary))]"><img src={g.image_url} alt="" className="w-full h-full object-cover" /></div>
              <div className="p-3 space-y-1">
                <div className="text-sm font-medium truncate">{g.title || "Untitled"}</div>
                <div className="text-xs text-muted-foreground truncate">By {g.uploader_name}</div>
                <div className="flex gap-2 mt-2">
                  {g.status !== "approved" && <Button size="sm" onClick={() => approve(g.id)} className="bg-[hsl(var(--primary))] text-[hsl(var(--primary-fg))]" data-testid={`gal-approve-${g.id}`}><Check className="h-4 w-4 mr-1" /> Approve</Button>}
                  {g.status !== "rejected" && <Button size="sm" variant="outline" onClick={() => reject(g.id)} data-testid={`gal-reject-${g.id}`}><X className="h-4 w-4 mr-1" /> Reject</Button>}
                  <Button size="icon" variant="ghost" onClick={() => remove(g.id)} data-testid={`gal-del-${g.id}`}><Trash2 className="h-4 w-4 text-destructive" /></Button>
                </div>
              </div>
            </Card>
          ))}
        </div>
      }
    </AppShell>
  );
}
